import { FC } from 'react';
import { Box, Text } from '@chakra-ui/react';

export const FormError: FC = ({ children }) => {
  return (
    <Box position='absolute'>
      <Text color='red.300' mt={2}>
        {children}
      </Text>
    </Box>
  );
};
